import { RemoveUserFromOrganizationEndAction } from "../actions/RemoveUserFromOrganization";
import { OrgState } from "../state";

export function removeUserFromOrganization(state: OrgState, action: RemoveUserFromOrganizationEndAction) {
    const { error, organizationId, userId } = action.payload;
    const users = state.users[organizationId];
    const newState: Partial<OrgState> = { error };

    if (error) {
        return { ...state, error };
    } else {
        const newUsers = users.filter(user => {
            return user.userId !== userId;
        });

        newState.users = { ...state.users };
        newState.users[organizationId] = newUsers;
    }

    return { ...state, ...newState };
}
